/*
 * Dispatch redesign: product renders come with slightly different off-white backdrops.
 * Sample each image's top-left corner and brighten just enough to turn that backdrop
 * white; the CSS multiply blend then leaves every product on the same tile colour.
 * Images served from another origin can't be sampled and keep the CSS default.
 */
(function () {
  const SELECTOR = '.dx-tile img, .card__media img, .product__media-item .media img';

  function normalise(img) {
    if (img.dataset.dxNormalised) return;
    img.dataset.dxNormalised = '1';
    try {
      const canvas = document.createElement('canvas');
      canvas.width = canvas.height = 40;
      const ctx = canvas.getContext('2d', { willReadFrequently: true });
      ctx.drawImage(img, 0, 0, 40, 40);
      let lo = 255; // darkest channel across the four corners: some renders have a gradient backdrop
      for (const [cx, cy] of [[1, 1], [36, 1], [1, 36], [36, 36]]) {
        const d = ctx.getImageData(cx, cy, 3, 3).data;
        for (let i = 0; i < d.length; i += 4) lo = Math.min(lo, d[i], d[i + 1], d[i + 2]);
      }
      if (lo < 200) return; // dark or full-bleed photo: leave it alone
      img.style.filter = `brightness(${Math.min(1.16, 255 / lo).toFixed(3)})`;
    } catch (e) {
      /* cross-origin image: keep the CSS default */
    }
  }

  function scan(root) {
    root.querySelectorAll(SELECTOR).forEach((img) => {
      if (img.complete && img.naturalWidth) normalise(img);
      else img.addEventListener('load', () => normalise(img), { once: true });
    });
  }

  scan(document);
  // Sections re-rendered by the theme editor, filters or quick add
  new MutationObserver((records) => {
    records.forEach((r) => r.addedNodes.forEach((n) => n.nodeType === 1 && scan(n)));
  }).observe(document.body, { childList: true, subtree: true });
})();
